<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="12" lg="12">
        <b-card>
          <div slot="header">
            Revenue Channel
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                <i class="fa fa-file-excel-o"></i>
                Export
              </button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
                <b-form-input v-model="filter" placeholder="Revenue Channel to Search"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size: smaller" :items="items"
            :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc" :filter="filter" @filtered="onFiltered" @row-clicked="rowClicked"
            show-empty :busy="isBusy">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(nomor)="data">
              {{ (tblData.page - 1) * tblData.limit + data.index + 1 }}
            </template>
            <template v-slot:cell(isactive)="data">
              <span v-if="data.item.isactive == 1"> Yes </span>
            </template>

            <template v-slot:cell(createdBy)="data">
             {{ data.item.createdBy }} @ {{ data.item.createdAt | moment('DD MMM YYYY') }}
            </template>
            
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>

            <template #empty="scope">
              <h6 class="text-center">{{ scope.emptyText }}</h6>
            </template>
            <template #emptyfiltered="scope">
              <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="7">
              <div class="pt-2">
                Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
                to
                <span v-if="tblData.page * tblData.limit > tblData.total">{{
                  tblData.total
                  }}</span>
                <span v-else>{{ tblData.page * tblData.limit }}</span>
                of {{ tblData.total }} entries

              </div>
            </b-col>
            <b-col>
              <div class="pt-2">
                <span class="ml-3 mr-1">limit per page :</span>
                <input type="number" style="width: 80px" v-model="tblData.limit" v-b-tooltip.hover
                  :title="`${tblData.limit} records`" />
              </div>
            </b-col>
            <b-col cols="5">
              <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
                v-model="tblData.page"></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="8">
        <b-card>
          <div slot="header">Revenue Channel - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend><label>Channel Category</label></b-input-group-prepend>
            <b-form-select v-model="frmdata.chanelCategoriId" :state="!$v.frmdata.chanelCategoriId.$error" :options="chanelCategories"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Medium</label></b-input-group-prepend>
            <b-form-select v-model="frmdata.mediumId" :state="!$v.frmdata.mediumId.$error"  :options="mediumOptions"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Sales Item</label></b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.salesItemInfo" :state="!$v.frmdata.salesItemKode.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesItemShow=true">
                                                    <i class="fa fa-search"></i>
                                                </b-btn>
            </b-input-group-append>
          </b-input-group>


          <div slot="footer" style="text-align: center">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal v-model="lkuSalesItemShow" size="lg" :hide-footer="true" title="List of Sales Items"  :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>   
  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 145px;
    }
  }
}
</style>
<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Channel from "../../apis/amg-chanel";
import moment from "moment";
import lkuItem from "../lookup/lkuLookupSales";

toastr.init();

export default {
  components:{lkuItem},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      chanelCategoriId: { required },
      mediumId: { required },
      salesItemKode: { required },
    },

    scheduleLinesObj: {
      dayofweek_no: { required },
      jamAwal: { required },
      jamAkhir: { required },
      lamaJadwal: { required },
    },

  },
  data() {
    return {
      inputBerlanjut: 0,
      showDelConfirm: false,
      lkuSalesItemShow:false,
      showList: true,
      showForm: false,
      isBusy: false,
      context: null,
      inputLineBerlanjut: 0,
      user:this.$store.state.user,
      frmdata: {
        kodelama:'',
        chanelCategoriId: "",
        mediumId:'',
        salesItemKode:'',
        salesItemInfo:'',
        isactive: 1, 
        // behaviour: 0,daysPerWeek:0
      },
      items: [],
      chanelCategories:[],
      mediumOptions:[],
      tblData: {
        tablename: "sales-revenue",
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: "chanelCategoriId",
        sortDesc: false,
      },
      tblFields: [
        {
          key: "nomor",
          label: "No.",
          thStyle: "width:30px",
        },
        {
          key: "channelCategoryName",
          label: "Channel Name",
          sortable: true,
        },
        {
          key: "mediumName",
          label: "Medium Name",
          sortable: true,
        },
        // {
        //   key: "behaviour",
        //   label: "Behaviour",
        //   sortable: true,
        // },
        {
          key: "salesItemInfo",
          label: "Sales Item",
          sortable: true,
        },
        {
          key: "createdBy",
          label: "Created",
          sortable: true,
        },
        
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        },
      ],
      filter: null,
      activeStatus: [
        { value: "", text: "-- ALL --" },
        { value: "0", text: "Non Active" },
        { value: "1", text: "Active/In Use" },
      ],
      
    };
  },
  computed: {
    invalidFormdataLinesObj() {
      this.$v.scheduleLinesObj.$touch();
      return this.$v.scheduleLinesObj.$invalid;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },

  watch: {
    "scheduleLinesObj.dayofweek_no": function (val) {
      if ((val || 0) !== "") {
        let getDetail = this.weekOfDay.find((x) => x.value == val);
        this.scheduleLinesObj.dayofweek_nm = getDetail.text;
      }
    },
  },

  created: async function () {
    console.log("#CEK.");
    this.data();
    let weekArray = moment.weekdays();
    // let dt=[{
    //   value: "",
    //   text: "SELECT DAYS",
    // }];
    let dt = [];
    weekArray.map((day, i) => {
      dt.push({
        value: i,
        text: day,
      });
    });
    this.weekOfDay = dt;

    let chCategory = await crud.list({ tablename: "chanel-category" });
    let chPlatform = await crud.list({ tablename: "chanel-platform" });
    let chUnit = await crud.list({ tablename: "chanel-unit" });
    let medium = await crud.list({ tablename: "medium" });
    // let chSchedule = await crud.list({ tablename: "playing-schedule" });
    this.chanelCategories = chCategory.reduce(
      (
        list = [{ value: "", text: "Please select an option" }],
        data,
        index
      ) => {
        list.push({
          value: data._id,
          text: data.name,
        });
        return list;
      },
      [{ value: "", text: "Please select an option" }]
    );

    this.mediumOptions = medium.reduce(
      (
        list = [{ value: "", text: "Please select an option" }],
        data,
        index
      ) => {
        list.push({
          value: data._id,
          text: data.name,
        });
        return list;
      },
      [{ value: "", text: "Please select an option" }]
    );
    this.chanelPlatforms = chPlatform.reduce(
      (
        list = [{ value: "", text: "Please select an option" }],
        data,
        index
      ) => {
        list.push({
          value: data._id,
          text: data.name,
        });
        return list;
      },
      [{ value: "", text: "Please select an option" }]
    );
    this.chanelUnits = chUnit.reduce(
      (
        list = [{ value: "", text: "Please select an option" }],
        data,
        index
      ) => {
        list.push({
          value: data._id,
          text: data.name,
        });
        return list;
      },
      [{ value: "", text: "Please select an option" }]
    );
  },
  methods: {
    onSelectLkuItem(_selected) {
            console.log
            this.lkuSalesItemShow=false;
            this.frmdata.salesItemInfo =_selected.saleCrCode.trim() + " | " + _selected.NamaSale.trim();
            this.frmdata.salesItemKode = _selected.kode;

        },
    getNameFromDayOfWeeks(val) {
      if (val == "" || val == undefined) return '';
      let dayMaps = "";
      val.split(',').map(dt => {
        let dtDay = this.dayOfWeeks.find(x => x.value == dt);
        if (dtDay) {
          dayMaps += dayMaps == "" ? "" : ","
          dayMaps += dtDay.text
        }
      });
      return dayMaps
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    onContext(ctx) {
      this.context = ctx
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        // this.tblData.customQuery=str;

        const response = await crud.exportxls(this.tblData);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `revenuechanel.xlsx`);
        document.body.appendChild(link);
        link.click();

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    data: async function (ctx) {
      try {
        this.isBusy = true;
        this.tblData.limit = 10000;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await crud.list(this.tblData);
        this.items = list;
        this.tblData.limit = 20;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    refresh(ctx) {
      // if (this.$refs.table) this.$refs.table.refresh();
      this.data();
    },
    add: function (data) {
      this.saveFilter();
      // router.push({name :'app.channel-form'});
      this.frmdata._id = "";
      this.frmdata.name = "";
      this.frmdata.categoryId = "";
      this.frmdata.platformId = "";
      this.frmdata.unitId = "";
      this.frmdata.isactive = 1;
      // this.frmdata.daysPerWeek=0;
      // this.frmdata.behaviour=0;
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      this.frmdata.name = "";
      this.frmdata.categoryId = "";
      this.frmdata.platformId = "";
      this.frmdata.unitId = "";
      this.frmdata.isactive = 0;
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data._id;
      this.showForm = true;
      this.showList = false;
    },
    async save() {
      if (this.invalidFormdata) {
        const invalidobj = {};
        for (var key in this.$v.frmdata) {
          if (this.$v.frmdata[key].$anyError) {
            if (this.$v.frmdata[key].$anyError == true)
              invalidobj[key] = this.$v.frmdata[key];
          }
        }
        console.log("validation model: ", this.frmdata);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.$bvModal
            .msgBoxConfirm("Are you sure save the data.", {
              title: "Please Confirm",
              size: "sm",
              okVariant: "success",
              okTitle: "YES",
              cancelTitle: "NO",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(async (value) => {
              if (value) {
                try {
                  this.isLoading = true;
                  if (this.frmdata.kodelama) {
                    await crud.update(
                      {
                        tablename: 'sales-revenue',
                        key: this.frmdata.kodelama,
                        data: {
                          chanelCategoriId:this.frmdata.chanelCategoriId,
                          mediumId:this.frmdata.mediumId,
                          salesItemKode:this.frmdata.salesItemKode,
                          salesItemInfo:this.frmdata.salesItemInfo,

                        }
                      });
                  } else {
                    await crud.insert(
                      {
                        tablename: 'sales-revenue',
                        data: {
                          chanelCategoriId:this.frmdata.chanelCategoriId,
                          mediumId:this.frmdata.mediumId,
                          salesItemKode:this.frmdata.salesItemKode,
                          salesItemInfo:this.frmdata.salesItemInfo,
                          createdBy:this.user.username,
                        }
                      });
                  }
                  this.closeFrm();
                  setTimeout(() => {
                    this.refresh();
                  }, 500);     


                  this.isLoading = false;

                } catch (error) {
                  this.isLoading = false;
                  if (error.sql) {
                    toastr.error(error.sql, "ERROR MESSAGE", 10000);
                  } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
                  } else if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE", 10000);
                  } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                  }
                }
              }
            })
            .catch((err) => {
              this.isLoading = false;
              // An error occurred
            });

        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await crud.remove({ tablename: "chanel", key: this.model._id });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    clearFilter(ctx) {
      this.filter.name = "";
      this.filter.categoryId = "";
      this.filter.platformId = "";
      this.filter.unitId = "";
      this.filter.isactive = "";
      this.refresh();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({ path: "home" });
    },
    saveFilter() {
      const keys = ['name', 'categoryId', 'platformId', 'isactive'];
      let filtered = false;
      const custlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          custlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        custlist.page = this.tblData.page;
        custlist.limit = this.tblData.limit;
        custlist.sortBy = this.tblData.sortBy;
        custlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.custlist = custlist;
        this.$store.commit("filter", filter);
      }
    },
  },
};
</script>
